import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_DBO_REPORT_QUERY_KEY = 'apa-dbo-report';

const getDBOReportQueryKey = (organizationId?: string) =>
  [APA_DBO_REPORT_QUERY_KEY, organizationId] as const;

const getDBOReportQueryOptions = ({
  organizationId,
}: {
  organizationId?: string;
}) =>
  queryOptions({
    queryKey: getDBOReportQueryKey(organizationId),
    queryFn: async () => {
      const { data } = await apiClient.apa.getDBOReport({
        organizationId: organizationId!,
      });
      return data || [];
    },
    enabled: !!organizationId,
  });

export const useDBOReportQuery = () => {
  const { currentOrganization } = useOrganizations();

  const { isLoading, data, error, refetch } = useQuery(
    getDBOReportQueryOptions({ organizationId: currentOrganization?.id })
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
